import api from '../services/api';

/** Legacy deployment hosts — rewrite to current site (keep in sync with fixImageUrls.js). */
const LEGACY_MEDIA_HOSTS = [
  'http://47.109.202.157:5012',
  'http://47.109.202.157:5011',
  'https://47.109.202.157:5012',
  'https://47.109.202.157:5011',
  'http://47.109.202.157',
  'https://47.109.202.157',
  'http://45.63.51.200:5012',
  'http://45.63.51.200:5011',
  'http://localhost:5001',
  'http://127.0.0.1:5001',
];

const mediaOrigin = (): string => {
  const base = (api.defaults.baseURL as string | undefined) || '/api';
  if (base.startsWith('http')) return new URL(base).origin;
  if (typeof window !== 'undefined') return window.location.origin;
  return '';
};

/** Resolve upload paths to absolute URLs (current site / dev API origin). */
export const resolveMediaUrl = (url?: string): string => {
  let raw = url?.trim() || '';
  if (!raw) return '';
  if (raw.startsWith('data:')) return raw;

  const origin = mediaOrigin();
  if (!origin) return raw;

  for (const old of LEGACY_MEDIA_HOSTS) {
    if (raw.startsWith(old)) {
      raw = raw.slice(old.length);
      break;
    }
  }

  if (raw.startsWith('/api/uploads/')) {
    return `${origin}${raw}`;
  }

  if (/^https?:\/\//i.test(raw)) {
    try {
      const parsed = new URL(raw);
      if (parsed.pathname.startsWith('/api/uploads/')) {
        return `${origin}${parsed.pathname}${parsed.search}`;
      }
    } catch {
      return raw;
    }
    return raw;
  }

  return new URL(raw.startsWith('/') ? raw : `/${raw}`, origin).toString();
};

/** Rewrite <img src> in rich text HTML to resolved media URLs. */
export const normalizeHtmlMediaUrls = (html?: string): string => {
  if (!html?.trim()) return html || '';
  return html.replace(
    /(<img[^>]+src=["'])([^"']+)(["'])/gi,
    (_match, pre, src, post) => `${pre}${resolveMediaUrl(src)}${post}`
  );
};

/** First <img src="..."> in HTML (abstract / rich text body). */
export const extractFirstImageFromHtml = (html?: string): string | null => {
  if (!html?.trim()) return null;
  const match = html.match(/<img[^>]+src=["']([^"']+)["']/i);
  return match?.[1]?.trim() || null;
};

/** Prefer abstract image, then first image in detailed introduction. */
export const getPublicationPreviewImage = (pub: {
  abstract?: string;
  content?: string;
}): string | null => {
  const fromAbstract = extractFirstImageFromHtml(pub.abstract);
  if (fromAbstract) return resolveMediaUrl(fromAbstract);
  const fromContent = extractFirstImageFromHtml(pub.content);
  if (fromContent) return resolveMediaUrl(fromContent);
  return null;
};
